import AgentFnMap, { AgentFnMapKey } from './agentFnMap';
import { Model } from '@viddsee/server-api-client';
import { Nullable } from '@/scripts/models/utility-types';
import { PscTrackerVideoInfo, PscTrackerMandatoryVideoInfo, PscTrackerOptionalVideoInfo, POST_INSTRUCTION, PscEventInstruction } from './PscTracker.declaration';

export default class PscCommandMaker {
  videoInfo: PscTrackerVideoInfo;

  constructor(video: Model.Video.Info) {
  /* eslint no-multi-spaces: 0 */
    const shouldSendOptional = true;

    const mandatory: PscTrackerMandatoryVideoInfo = {
      /* Video-Type */             cp1: '1',
      /* Video-ID */               cp2: `${video.id}`,
      /* Video-Title */            cp3: video.title,
      /* Video-Duration */         cp4: `${video.durationSeconds}`,

      /* Language */               cp13: 'en',
    };

    const optional: PscTrackerOptionalVideoInfo = {
      /* Ad-ID */                  cp5: 'null',
      /* Video-Part-ID */          cp6: 'null',
      /* Video-Part-Title */       cp7: 'null',
      /* Video-Part-Duration */    cp8: 'null',
      /* Airtime */                cp9: 'null',

      /* Web-Status */             cp10: 'null',
      /* Pay-Status */             cp11: 'null',
      /* Video-URL */              cp12: 'null',

      /* Program-Name */           cp14: 'null',
      /* TV-Channel */             cp15: 'null',
      /* Program-ID */             cp16: 'null',
    };

    // Result
    this.videoInfo = mandatory;
    if (shouldSendOptional) {
      this.videoInfo = {
        ...this.videoInfo,
        ...optional,
      };
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  createPSCEventInstruction(eventName: AgentFnMapKey, ...payloads: any[]): Nullable<PscEventInstruction> {
    const agentFnName = AgentFnMap[eventName];

    if (!agentFnName) return null;

    return {
      instruction: POST_INSTRUCTION,
      payload: {
        eventName: agentFnName,
        params: (agentFnName === AgentFnMap.load) ? this.videoInfo : null,
        payloads,
      },
    };
  }

  filterPscEventMaker(videoPlayerEvent: AgentFnMapKey, ...payloads: any[]): Nullable<PscEventInstruction> {
    const hasValidEvent = !!AgentFnMap[videoPlayerEvent];
    if (hasValidEvent) {
      return this.createPSCEventInstruction(videoPlayerEvent, ...payloads);
    }
    return null;
  }
};
